export default __webpack_public_path__ + "static/media/system_02_08.c69dfbb8.jpg";